<template>
  <v-container grid-list-xl>
    <v-row wrap>
      <v-col cols="12">
        <v-alert dense text class="body-2 mt-5" type="info">
          <b>Mutasi Masuk</b> adalah proses mutasi pegawai yang selesai atay dalam proses dari instansi luar ke instansi
          Anda. Sendangkan <b>Mutasi Keluar</b> adalah proses mutasi pegawai yang selesai atau dalam proses dari
          instansi Anda ke instansi luar
        </v-alert>
      </v-col>
      <v-col cols="12">
        <m-card-list
          title="Mutasi Pegawai"
          label-cari="Cari Pegawai"
          :add="isCan('mutasi.store')"
          search
          refresh
          :items="items"
          :headers="headers"
          @search="
            (search) => {
              textSearch = search
              load()
            }
          "
          :page="page"
          @change:page="
            (pg) => {
              cp = pg
              load()
            }
          "
          @refresh="load()"
          @add="add"
          footer
        >
          <template v-slot:items="{ item }">
            <tr v-if="$vuetify.breakpoint.smAndUp">
              <td>
                <v-row wrap class="pt-5">
                  <v-col cols="3" align="center" justify="center">
                    <v-avatar :size="35" color="grey lighten-4 mr-2">
                      <img :src="'img/cowok.png'" alt="avatar" />
                    </v-avatar>
                  </v-col>
                  <v-col cols="9">
                    <p class="font-weight-bold my-0 py-0"> {{ pVal(item.users, 'nama') }} </p>
                    <p class="grey--text caption"> {{ pVal(item.users, 'no_pegawai') }} </p>
                  </v-col>
                </v-row>
              </td>
              <td>
                {{ pVal(item.organisasi_asal, 'nama') || '' }}
              </td>
              <td>
                {{ pVal(item.organisasi_tujuan, 'nama') || '' }}
              </td>
              <td>
                <span :class="isOrganisasiAsal(item.organisasi_id_asal) ? 'grey--text text--darken-1' : 'orange--text'">
                  {{ isOrganisasiAsal(item.organisasi_id_asal) ? '• Keluar' : '• Masuk' }}
                </span>
              </td>
              <td>
                <v-chip :color="mStatus[item.k_status]['color']" outlined small>
                  {{ item && item.is_ajuan_tenant === 1 ? 'Tenant' : mStatus[item.k_status]['text'] }}
                </v-chip>
              </td>
              <td>
                <v-btn color="primary" depressed small @click="onDetail(item)">
                  <v-icon left>mdi-magnify</v-icon> Periksa
                </v-btn>
              </td>
            </tr>
            <tr v-else>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">Nama</div>
                <div class="v-data-table__mobile-row__cell title"> </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">
                  Surel
                </div>
                <div class="v-data-table__mobile-row__cell grey--text"> </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">
                  Nomor Pegawai
                </div>
                <div class="v-data-table__mobile-row__cell grey--text"> </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">Peran</div>
                <div class="v-data-table__mobile-row__cell"> </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">
                  Verifikasi Wajah
                </div>
                <div class="v-data-table__mobile-row__cell"> </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">
                  Status Pengguna
                </div>
                <div class="v-data-table__mobile-row__cell"> </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2"> </div>
                <div class="v-data-table__mobile-row__cell"> </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">Aksi</div>
                <div class="v-data-table__mobile-row__cell"> </div>
              </td>
            </tr>
          </template>
        </m-card-list>
      </v-col>
    </v-row>
    <FormMutasi ref="form" :users="user" :organisasis="organisasi" @refresh="load"></FormMutasi>
    <FormKonfirmasi ref="konfirmasi" @refresh="load"></FormKonfirmasi>
  </v-container>
</template>
<script>
import FormMutasi from '../components/Form'
import FormKonfirmasi from '../components/Konfirmasi'
import { M_STATUS } from '@/modules/mutasi/const'
export default {
  components: { FormMutasi, FormKonfirmasi },
  data() {
    return {
      title: null,
      items: [],
      page: null,
      cp: 1,
      kuota: null,
      textSearch: '',
      headers: [
        { text: 'Anggota', align: 'left', value: 'nama', sortable: false },
        { text: 'Organisasi Asal', align: 'left', value: 'asal', sortable: false },
        {
          text: 'Organisasi Tujuan',
          align: 'left',
          value: 'is_face_verified',
          sortable: false,
        },
        { text: 'Jenis Mutasi', align: 'left', value: 'is_aktif', sortable: false },
        { text: 'Status', align: 'left', value: 'k_status', sortable: false },
        { text: '', align: 'center', sortable: false },
      ],
      more_menu: [
        // eslint-disable-next-line
        {
          title: 'Detail',
          click: () =>
            this.$router.push({
              name: 'user.detail',
              params: {},
            }),
        },
      ],
      user: [],
      organisasi: [],
      mStatus: M_STATUS,
    }
  },
  activated() {
    this.reset()
    this.load()
    this.loadUsers()
    this.loadOrganisasis()
  },
  methods: {
    reset() {
      this.items = []
      this.organisasi = []
      this.user = []
    },

    add() {
      this.$refs.form.open()
    },

    load() {
      this.$store
        .dispatch('mutasi/fetch', {
          organisasi_id: this.organisasi_id,
          params: {
            page: this.cp,
            keyword: this.textSearch,
          },
        })
        .then((res) => {
          this.page = res.data
          this.items = res.data.data
        })
        .catch((e) => e)
    },

    loadUsers() {
      this.$store
        .dispatch('user/get', {
          organisasi_id: this.organisasi_id,
          params: { count: 500, is_aktif: 1 }
        })
        .then(({ data }) => {
          this.user = data || []
        })
    },

    loadOrganisasis() {
      this.$store
        .dispatch('organisasi/get',
          {
            count: 100,
            kode_tenant: this.tenant_id
          })
        .then(({ data }) => {
          this.organisasi = ((data && data.data) || []).filter((s) => s.kode_organisasi !== this.organisasi_id)
        })
    },

    isOrganisasiAsal(id) {
      return Number(this.current_organisasi && this.current_organisasi.organisasi_id) === Number(id)
    },

    getOrganisasi(id) {
      return (this.organisasi || []).find((s) => s.organisasi_id === Number(id)) || {}
    },

    async onDetail(item) {
      const data = await this.$store
        .dispatch('mutasi/getDetail', { organisasi_id: this.organisasi_id, id: item.mutasi_id })
        .then(({ data }) => data)

      let init = Object.assign({}, data, {
        is_asal: this.isOrganisasiAsal(item.organisasi_id_asal),
      })

      this.$refs.konfirmasi.open(init)
    },
  },
}
</script>
